import { getAPIUrl } from '../constants/uri';
import {isCourseComingSoon} from "../course/course-helper";

class CourseService {

    async fetchCoursesSliderList(filterComingLater = true) {
        const result = await (await fetch(getAPIUrl() + "/content/course/sliderList")).json();

        let res = result.courseOrdering.ordering.map(c => c.course)
            .filter(c => c !== null);

        if (filterComingLater) {
            res = res.filter(c => {
                if (isCourseComingSoon(c)) return false;
                if (c.state === "draft") return false;
                return true;
            });
        }

        return res;
    }

    async fetchCoursesSliderListWithVideos(filterComingLater = true) {
        const result = await (await fetch(getAPIUrl() + "/content/course/sliderListWithVideos")).json();

        let res = result.courseOrdering.ordering.map(c => c.course)
            .filter(c => c !== null);

        if (filterComingLater) {
            res = res.filter(c => {
                if (isCourseComingSoon(c)) return false;
                if (c.state === "draft") return false;
                return true;
            });
        }

        return res;
    }

    async fetchCourseSliderListForCourse(courseId) {
        const result = await (await fetch(getAPIUrl() + "/content/course/sliderListForCourse/" + courseId)).json();

        const overwrite = result.landingpageCoursesOverwrite.filter(d => d).map( d => d.course );
        const allCourses = await this.fetchCoursesSliderList();

        return [
            ...overwrite,
            ...allCourses.filter( a => !overwrite.find(e => e?.id === a.id) && a.id !== courseId )
        ];
    }

    async fetchCourseDetail(uuid) {
        const result = (await fetch(getAPIUrl() + "/content/course/courseDetailByUuid/" + uuid)).json();
        return result;
    }

    async fetchCourseDetailBySlug(slug) {
        const result = (await fetch(getAPIUrl() + "/content/course/courseDetailBySlug/" + slug)).json();
        return result;
    }

}

export default CourseService;
